import { TypeChecker } from '@attain-apps/type-guards'

import type { Feature } from './feature'

export class Selectors {
  /** TODO:  */
  public readonly outcomes
  /** TODO:  */
  public readonly units
  /** TODO:  */
  public readonly assignments
  /** TODO:  */
  public readonly assignmentsFilters

  /** TODO:  */
  public readonly shouldPresentData
  /** TODO:  */
  public readonly error
  /** TODO:  */
  public readonly shouldPresentLoading

  constructor(feature: Feature) {
    const outcomesEntry = feature.state.project(state => state.outcomes)
    const unitsEntry = feature.state.project(state => state.units)
    const assignmentsEntry = feature.state.project(state => state.assignments)

    this.shouldPresentData = outcomesEntry.project(
      assignmentsEntry.asSelector,
      unitsEntry.asSelector,
      (outcomes, assignments, units) =>
        [outcomes.data, assignments.data, units.data].every(
          TypeChecker.isNotFalsish.raw,
        ),
    )

    this.error = outcomesEntry.project(
      assignmentsEntry.asSelector,
      unitsEntry.asSelector,
      (outcomes, assignments, units) =>
        [outcomes.error, assignments.error, units.error].find(
          TypeChecker.isFalsish.raw,
        ),
    )

    this.shouldPresentLoading = outcomesEntry.project(
      assignmentsEntry.asSelector,
      unitsEntry.asSelector,
      (outcomes, assignments, units) =>
        [outcomes.loading, assignments.loading, units.loading].some(
          TypeChecker.isNotFalsish.raw,
        ),
    )

    this.assignments = assignmentsEntry.project(state => state.data ?? [])
    this.outcomes = outcomesEntry.project(state => state.data ?? [])
    this.units = unitsEntry.project(state => state.data ?? [])
    this.assignmentsFilters = feature.state.project(
      state => state.assignmentsFilters,
    )
  }
}
